import {
	Pipe,
	PipeTransform,
} from '@angular/core';
import {
	forEach,
	keys,
} from 'lodash';

@Pipe({
	name: 'translateParams',
})
export class CommonTranslateParamsPipe implements PipeTransform {
	transform (value: string, params: {[key: string]: string }): string {
		forEach(keys(params), (key) => {
			value = value.replace(new RegExp('{' + key + '}', 'g'), params[key]);
		});

		return value;
	}
}
